import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import AddBloodSugarMeasurementMutation from './AddBloodSugarMeasurementMutation';
import BloodSugarQuery from '../Fetch/BloodSugarQuery';
import BloodSugarDaysQuery from '../FetchDays/BloodSugarDaysQuery';

const AddBloodSugarMeasurementConnectorApollo = ({ children }) => {
  const [addBloodSugar, { data, loading, error }] = useMutation(AddBloodSugarMeasurementMutation);

  const createAddBloodSugarMeasurement = async (request) => {
    const response = await addBloodSugar({
      variables: { request },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: BloodSugarQuery,
        },
        {
          query: BloodSugarDaysQuery,
          variables: { days: 8 },
        },
      ],
    });

    return response;
  };

  return children({
    addMeasurement: {
      addBloodSugarMeasurement: createAddBloodSugarMeasurement,
      response: data,
      loading,
      error,
    },
  });
};

AddBloodSugarMeasurementConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default AddBloodSugarMeasurementConnectorApollo;
